var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 5C2.25 3.48122 3.48122 2.25 5 2.25H19C20.5188 2.25 21.75 3.48122 21.75 5V14C21.75 15.5188 20.5188 16.75 19 16.75H12.9367C12.5658 16.75 12.214 16.9148 11.9765 17.1998L9.34439 20.3583C8.29655 21.6157 6.25 20.8747 6.25 19.2379V17C6.25 16.8619 6.13807 16.75 6 16.75H5C3.48122 16.75 2.25 15.5188 2.25 14V5ZM5 3.75C4.30964 3.75 3.75 4.30964 3.75 5V14C3.75 14.6904 4.30964 15.25 5 15.25H6C6.9665 15.25 7.75 16.0335 7.75 17V19.2379C7.75 19.4718 8.04237 19.5776 8.19205 19.398L10.8241 16.2395C11.3466 15.6125 12.1206 15.25 12.9367 15.25H19C19.6904 15.25 20.25 14.6904 20.25 14V5C20.25 4.30964 19.6904 3.75 19 3.75H5Z",
    fill: "#022220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnComment);
export default __webpack_public_path__ + "static/media/icn_comment.f6353c5672fb5431c939c42c696b8819.svg";
export { ForwardRef as ReactComponent };